import { userInfoFrag } from '../../../../utils/type/user.common-type';
import { addressFrag } from '../../../../services/types/common.types';
import { addressInfoFrag } from '../../../../utils/type/address.common-type';
import { personInfoFrag } from '../../../../utils/type/person.common-type';
import { workParticipantsFrag } from '../../../../services/types/work.types';

export const getUsersFrag = `
    ${userInfoFrag}
    workplaces(input: __WORKPLACE_INPUT__) {
        address {
            ${addressInfoFrag}
        }
    }
`;

export const getFolderByPersonFrag = `
    id
    closedAt
    disposalState
    serviceAddressId
    workplaces {
        workplaceId
        dateFrom
        dateTo
    }
`;

export const getPersonAddressesFrag = `
    id
    addresses {
        id
        validFrom
        validTo
        type
        address {
            ${addressFrag}
        }
    }
`;

export const getServiceAreasFrag = `
    id
    name
    description
    mpsvRegion
`;

export const getContractFrag = `
    id
    leadTime {
        fixedTime
    }
`;

export const getWorkDetailFrag = `
    id
    workType
    serviceId
    dateFrom
    dateTo
    isBilled
    folderId
    users {
        ${userInfoFrag}
    }
    tags
    ${workParticipantsFrag}
    workData {
        ... on WorkDataIndividualWorkObject {
            note
            vehicle
            form
            addressFrom {
                ${addressInfoFrag}
            }
            addressTo {
                ${addressInfoFrag}
            }
            distanceFrom
            distanceTo
            timeFrom
            timeTo
            leadTime
            useLeadTime
        }
    }
    person {
        ${personInfoFrag}
    }
    offers {
        id
        offerId
        applications
        payByCredits
        operations
        procedures
        dateFrom
        dateTo
        durationNote
        durationPreparation
        durationSelfReflection
        tags
        areas
        users
        executions
        note
        presence
        type
        serviceOffer {
            code
            name
            color
        }
        targets {
            targetId
            folderId
        }
        projects {
            projectId
        }
    }
    relatedWorks {
        id
        workData {
            ... on WorkDataOperationalReportObject {
                type
                priority
                description
                users {
                    ${userInfoFrag}
                }
            }
        }
    }
`;
